import { useState } from "react";

function ScheduledNotificationRecipients({ userIds, displayName }) {
    const [isCollapsed, setIsCollapsed] = useState(true);
    const displayNames = userIds.map(displayName).filter(Boolean);
    const initialDisplayNames = displayNames.slice(0, 4);
    const remainingDisplayNames = displayNames.slice(4);

    if (displayNames.length === 0) {
        return <span>-</span>;
    }

    return (
        <>
            {isCollapsed ? initialDisplayNames.join(', ') : displayNames.join(', ')}
            {remainingDisplayNames.length > 0 ? (
                <button
                    type="button"
                    className="inline-link-button"
                    onClick={() => setIsCollapsed(!isCollapsed)}
                >
                    {isCollapsed ? ` i ${remainingDisplayNames.length} més` : ' mostrar menys'}
                </button>
            ) : null}
        </>
    );
}

export default ScheduledNotificationRecipients;
